<template>
  <div>
    <div class="modal fade" id="currencyModal" ref="modalEle" tabindex="-1">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <div class="modal-header">
            <h5 class="modal-title">Waluty</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <h6 class="mb-0">Lista walut</h6>
              <button class="btn btn-sm btn-success" @click="addCurrency" :disabled="addingNew">
                <i class="bi bi-plus-lg me-1"></i>
                Dodaj walutę
              </button>
            </div>

            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Nazwa</th>
                    <th>Kurs do PLN</th>
                    <th>Data kursu</th>
                    <th>Użyta</th>
                    <th>Akcje</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="addingNew">
                    <td>Nowa</td>
                    <td>
                      <input v-model="newCurrency.name" class="form-control">
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <button class="btn btn-sm btn-success me-2" @click="saveNewCurrency"><i class="bi bi-save me-1"></i>Zapisz</button>
                      <button class="btn btn-sm btn-danger" @click="cancelNewCurrency"><i class="bi bi-x-circle me-1"></i>Anuluj</button>
                    </td>
                  </tr>
                  <tr v-for="(currency, index) in filteredCurrencys" :key="currency.id">
                    <td>{{ index + 1 }}</td>
                    <td>
                      <input v-if="editingId === currency.id" v-model="currency.name" class="form-control">
                      <span v-else>{{ currency.name }}</span>
                    </td>
                    <td>{{ currency.rate }}</td>
                    <td>{{ currency.date }}</td>
                    <td>{{ (currency.articles_count ?? 0) + (currency.delegacje_koszty_count ?? 0) }}</td>
                    <td>
                      <button v-if="editingId === currency.id" class="btn btn-sm btn-success me-2"
                        @click="updateCurrency(currency)">
                        <i class="bi bi-save me-1"></i>
                        Zapisz
                      </button>
                      <button v-else class="btn btn-sm btn-outline-info me-2" @click="editCurrency(currency.id)">
                        <i class="bi bi-pencil me-1"></i>
                        Edytuj
                      </button>
                      <button v-if="(currency.articles_count + currency.delegacje_koszty_count) === 0"
                        class="btn btn-sm btn-danger" @click="deleteCurrency(currency.id)">
                        <i class="bi bi-trash me-1"></i>Usuń
                      </button>
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-outline-secondary" data-bs-dismiss="modal">Zamknij</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from "bootstrap";

export default {

  props: {
    currencys: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      modalObj: null,
      editingId: null,
      addingNew: false,
      newCurrency: this.getEmptyForm()
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle);
  },
  computed: {
    filteredCurrencys() {
      return this.currencys.filter(currency => currency.name !== 'PLN');
    }
  },
  methods: {
    getEmptyForm() {
      return {
        id: null,
        name: ''
      }
    },

    resetForm() {
      this.editingId = null;
      this.addingNew = false;
      this.newCurrency = this.getEmptyForm();
    },

    addCurrency() {
      this.addingNew = true;
      this.newCurrency = this.getEmptyForm();

    },
    cancelNewCurrency() {
      this.addingNew = false;
      this.newCurrency = this.getEmptyForm();
    },
    editCurrency(id) {
      this.editingId = id;
    },

    updateCurrency(currency) {
      this.$emit("update-currency", { ...currency });
      this.resetForm();
      this.hide();
    },

    saveNewCurrency() {
      if (!this.newCurrency.name) {
        this.errorMsg("Podaj nazwę waluty.");
        return;
      }

      this.$emit("save-currency", this.newCurrency);
      this.resetForm();
      this.hide();

    },
    deleteCurrency(id) {
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie waluty',
        html: 'Czy na pewno usunąć walutę?',
        showConfirmButton: true,
        showDenyButton: true,
        confirmButtonText: 'Tak',
        denyButtonText: 'Nie',
        timer: false,
        position: 'center'
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("delete-currency", id);
          this.resetForm();
          this.hide();
        }
      });
    },

    show() {
      this.modalObj.show();
    },

    hide() {
      this.resetForm();
      this.modalObj.hide();
    },

    errorMsg(msg) {
      Toast.fire({
        toast: true,
        position: 'top-end',
        icon: 'warning',
        title: 'Błąd',
        html: msg,
        timer: 2500,
        showConfirmButton: false
      });
    }
  }
}
</script>